import type { NewListTicket } from "./NewTicketsTypes";

export type NewTicketsSortDirection = "asc" | "desc";

function getSortValue(columnId: string, ticket: NewListTicket): string | number {
  switch (columnId) {
    case "section":
      return (ticket.section || "").toLowerCase();
    case "row": {
      const raw = String(ticket.row ?? "");
      const n = Number.parseFloat(raw);
      return Number.isFinite(n) ? n : raw.toLowerCase();
    }
    case "seat":
      return (ticket.seat_range || "").toLowerCase();
    case "status":
      return (ticket.tp_status || "").toLowerCase();
    case "price":
    case "sale_price":
      return ticket.tp_list_price ?? 0;
    case "payout":
      return ticket.tp_sold_amount ?? 0;
    default:
      return "";
  }
}

/** Client-side sort for the current page of grouped tickets (API has no order_by). */
export function sortNewTicketsPage(
  items: NewListTicket[],
  columnId: string | null,
  direction: NewTicketsSortDirection
): NewListTicket[] {
  if (!columnId || items.length === 0) {
    return items;
  }
  const mult = direction === "asc" ? 1 : -1;
  return [...items].sort((a, b) => {
    if (columnId === "eventName") {
      const da = a.event_date_time || a.event_date || "";
      const db = b.event_date_time || b.event_date || "";
      if (da < db) {
        return -1 * mult;
      }
      if (da > db) {
        return 1 * mult;
      }
      return 0;
    }

    const va = getSortValue(columnId, a);
    const vb = getSortValue(columnId, b);
    if (typeof va === "number" && typeof vb === "number") {
      if (va !== vb) {
        return (va - vb) * mult;
      }
    } else {
      const sa = String(va);
      const sb = String(vb);
      if (sa < sb) {
        return -1 * mult;
      }
      if (sa > sb) {
        return 1 * mult;
      }
    }
    const da = a.event_date_time || "";
    const db = b.event_date_time || "";
    if (da < db) {
      return -1 * mult;
    }
    if (da > db) {
      return 1 * mult;
    }
    return 0;
  });
}
